import React, { useEffect, useState } from "react";
import { Button, Typography } from "@material-ui/core";
import { TextInput } from "@suralink/samurai/components";
import { useTheme, ThemeProvider } from "@material-ui/core/styles";
import { connect } from "react-redux";
import * as actions from "../redux/actions";
import { suraTheme } from "@suralink/samurai/themes";

interface subdomainProps {
  toggleSubdomain: any;
}

interface StateProps {}

interface DispatchProps {
  checkIfSubdomain: (subdomain: string) => any;
}

type Props = subdomainProps & StateProps & DispatchProps;

const SubdomainSearch: React.FC<Props> = ({
  toggleSubdomain,
  checkIfSubdomain,
}) => {
  const [subdomain, setSubdomain] = useState("");
  const [errorText, setErrorText] = useState("");

  const theme: any = useTheme();

  const BackText = "< Back";

  useEffect(() => {
    if (subdomain.length > 0 && errorText) {
      setErrorText("");
    }
  }, [subdomain, errorText]);

  async function checkSubdomain(): Promise<void> {
    if (subdomain) {
      try {
        await checkIfSubdomain(subdomain).then((res: any) => {
          // if response, then redirect to that
          console.log("res", res);
        });
      } catch (error: any) {
        console.log(error);
        setErrorText("We can't find a firm that matches this URL.");
      }
    }
  }

  return (
    <ThemeProvider theme={suraTheme}>
      <div
        style={{
          padding: "3.75rem 5rem",
          width: "32.5rem",
          border: "1px solid",
          borderColor: theme.palette.grey[200],
          borderRadius: "0.5rem",
        }}
      >
        <div style={{ marginBottom: "3rem" }}>
          <Button variant="text" onClick={() => toggleSubdomain(false)}>
            {BackText}
          </Button>
        </div>
        <form>
          <div style={{ textAlign: "center" }}>
            <Typography variant="h2" style={{ marginBottom: "1.5rem" }}>
              Sign in to your firm
            </Typography>
            <Typography variant="body1">
              Enter your firms Suralink URL. It's usually the name of the firm.
            </Typography>
          </div>
          <div style={{ display: "flex", margin: "1.5rem 0" }}>
            <TextInput
              value={subdomain}
              onChange={(e: any) => {
                setSubdomain(e.target.value.trim());
              }}
              placeholder="Firm subdomain"
              autoFocus={true}
              error={errorText}
              errorMessage={errorText}
            />
            <Typography
              variant="h5"
              style={{ marginLeft: "0.5rem", marginTop: "5px" }}
            >
              .suralink.com
            </Typography>
          </div>
          <Button
            color="primary"
            variant="contained"
            style={{
              width: "100%",
              margin: "auto",
            }}
            onClick={(e: any) => {
              e.preventDefault();
              checkSubdomain();
            }}
          >
            Continue
          </Button>
          <hr
            style={{
              margin: "3rem auto",
            }}
          />
          <div
            style={{ maxWidth: "240px", textAlign: "center", margin: "auto" }}
          >
            <Typography variant="h6">Having trouble?</Typography>
            <Typography variant="subtitle2" style={{ marginTop: "10px" }}>
              Reach out to your firm contact for their Suralink subdomain.
            </Typography>
          </div>
        </form>
      </div>
    </ThemeProvider>
  );
};

const mstp = (state: InitialStateModel): StateProps => {
  return {};
};

const matp = ((): DispatchProps => {
  const { checkIfSubdomain } = actions;
  return {
    checkIfSubdomain,
  };
})();

export default connect(mstp, matp)(SubdomainSearch);
